import React from 'react';
import rehypeRaw from 'rehype-raw';
import ReactMarkdown from 'react-markdown';

export default function PatientDocumentMarkdown({ content, signatureUrl }) {
  const blockStyle = {
    breakInside: 'avoid-page',
    pageBreakInside: 'avoid',
    WebkitColumnBreakInside: 'avoid',
    lineHeight: '1.6',
    marginBottom: '1em',
    width: '100%',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    maxWidth: '100%',
    boxSizing: 'border-box'
  };

  const signatureImageStyle = {
    maxWidth: '200px',
    height: 'auto',
    display: 'block',
    margin: '0 auto',
  };

  const listContainerStyle = {
    ...blockStyle,
    paddingLeft: '1.2em',
    marginBottom: '1em',
  };

  const listItemStyle = {
    ...blockStyle,
    display: 'list-item',        // real list-item so bullet shows
    listStyleType: 'disc',       // ensure disc bullets
    listStylePosition: 'outside',
    breakInside: 'avoid-page',
    pageBreakInside: 'avoid',
    WebkitColumnBreakInside: 'avoid',
    marginBottom: '0.6em',
  };

  // Process content to insert signature at signature line
  const processedContent = content.replace(
    /<div class="signature-line">.*?<\/div>/g,
    signatureUrl 
      ? `<div class="signature-line"><img src="${signatureUrl}" alt="Signature" style="max-width: 200px; height: auto; display: block; margin: 0 auto;" /></div>`
      : '<div class="signature-line"></div>'
  );

  return (
    <div style={{ width: '100%', overflow: 'hidden' }}>
      <ReactMarkdown
        rehypePlugins={[rehypeRaw]}
        components={{
          h1: ({ node, ...props }) => (
            <h1
              style={{
                ...blockStyle,
                fontSize: '1.5em',
                margin: '1em 0',
                textAlign: 'center',
              }}
              {...props}
            />
          ),
          h2: ({ node, ...props }) => (
            <h2
              style={{
                ...blockStyle,
                fontSize: '1.25em',
                marginTop: '1em',
                marginBottom: '0.5em',
              }}
              {...props}
            />
          ),
          p: ({ node, ...props }) => (
            <p style={blockStyle} {...props} />
          ),
          ul: ({ node, ...props }) => (
            <ul style={listContainerStyle} {...props} />
          ),
          ol: ({ node, ...props }) => (
            <ol style={listContainerStyle} {...props} />
          ),
          li: ({ node, ...props }) => (
            <li style={listItemStyle} {...props} />
          ),
        }}
      >
        {processedContent}
      </ReactMarkdown>
    </div>
  );
}
